import { ProjectRegisterConfirmationModule } from './project/project-register-confirmation.module';
import { NgModule } from "@angular/core";

@NgModule({
  imports: [
    ProjectRegisterConfirmationModule
  ]
})
export class ProjectsRepositoryRegisterConfirmationModule {}